export const invalidFunction = (message: string) => () => {
  throw new Error(message);
};



// WEBPACK FOOTER //
// ../../src/invalidFunction.ts